export default __webpack_public_path__ + "static/d11-3a4e61e175165cd716ce5d579c2c9c9f.png";